import { FunctionComponent } from "react";
import { HorizontalScroll } from "../horizontal-scroll";
import ProductCard from "../ProductCard";

type Props = {
  products: CarouselExtended;
};

const FeaturedCatalog: FunctionComponent<Props> = ({ products }) => {
  return (
    <div className="featured_catalog_container">
      <HorizontalScroll
        scrollBy={293}
        size={293}
        catalogScroll
        items={products.products.length}
      >
        <div className="featured_scroll">
          {products.products.length > 0 &&
            products.products.map((p) => {
              return (
                <ProductCard
                  title={p.productId?.title}
                  key={p.productId?._id}
                  img={p.productId?.thumbnailUrl}
                  friendlyUrl={p.productId?.friendlyUrl}
                  sku={p.productId?.sku}
                />
              );
            })}
        </div>
      </HorizontalScroll>
    </div>
  );
};

export default FeaturedCatalog;
